import { CssBaseline, ThemeProvider } from '@mui/material';
import useSettings from '../../hooks/useSettings';

const MatxTheme = ({ children }) => {
    const { settings } = useSettings();
    const activeTheme = { ...settings.themes[settings.activeTheme] };

    return (
        <ThemeProvider theme={activeTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default MatxTheme;
